import { client } from '@/lib/api/client'
import { MANAGED_VENUES_PATH } from '@/lib/api/config'
import { toApiError } from '@/lib/api/errors'

import type { VenueRegisterResult, VenueRegisterSaveInput } from './venueRegisterTypes'

/**
 * `POST /venue/v1/manager/venues` — 무료 구장 등록(api-spec §1).
 *
 * 🚨 같은 경로의 `GET`(`fetchManagedVenues`)과 자원을 공유한다 — 신규 경로 상수를 만들지 않고
 * `MANAGED_VENUES_PATH` 를 그대로 쓴다. 응답이 코트·오류 필드까지 등록 완료 화면을 그리는 데 필요한
 * 값을 전부 담고 있으므로, 호출부는 이 응답 하나로 다음 화면을 그려야 한다(재조회 금지).
 */
export async function registerVenue(input: VenueRegisterSaveInput): Promise<VenueRegisterResult> {
  try {
    const { data } = await client.post<VenueRegisterResult>(MANAGED_VENUES_PATH, input)
    return data
  } catch (error) {
    throw toApiError(error)
  }
}
